module.exports = __webpack_public_path__ + "img/42_3.c7f97f9e.png";